import { useQuery } from '@apollo/client';
import { Spinner } from '../../../components';
import FetchError from '../../../components/generic/FetchError';
import { useSearchParams } from 'react-router-dom';
import { FETCH_LOCATION_EXPOSURE } from '../queries/RiskHub';
import NoAvailableData from '../../../components/assets/NoAvailableData';
import FinancialData from '../../../components/common/FinancialData';
import QueryErrorBoundary from '../../../components/error-handling';

const LocationExposure = () => {
  let [searchParams] = useSearchParams();

  const locationUuid = searchParams.get('location');

  const { data, loading, error } = useQuery(FETCH_LOCATION_EXPOSURE, {
    variables: {
      filter: { locationUuid },
    },
    skip: !locationUuid,
  });

  const riskHubData = data?.exposureForRebuildTime;

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <>
      <QueryErrorBoundary error={error}>
        <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative">
          <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
            REVENUE EXPOSURE
          </h2>
          <div className="h-[200px] p-4 flex flex-col justify-between">
            {riskHubData ? (
              <>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-primary-100 text-sm font-bold tracking-wider">
                      Total Exposure
                    </h4>
                    <div className="text-primary-100 text-sm font-normal">
                      {riskHubData.rebuildTime}-month rebuild
                    </div>
                  </div>
                  <div className="text-xl text-blue font-normal tracking-wider">
                    {<FinancialData text={riskHubData.totalExposure} />}
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-primary-100 text-sm font-bold tracking-wider">
                      Mitigation
                    </h4>
                  </div>
                  <div className="text-xl text-blue font-normal tracking-wider">
                    {<FinancialData text={riskHubData.mitigation} />}
                  </div>
                </div>
                <div className="h-0 w-full border border-secondary-100 border-dashed"></div>
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-primary-100 text-sm font-bold tracking-wider">
                      Residual Exposure
                    </h4>
                  </div>
                  <div className="text-2xl text-blue font-bold tracking-wider">
                    {<FinancialData text={riskHubData.residualExposure} />}
                  </div>
                </div>
              </>
            ) : (
              <NoAvailableData helpText="Select a location first" />
            )}
          </div>
        </div>
      </QueryErrorBoundary>
    </>
  );
};

export default LocationExposure;
